export const environment = {
  origin: '/prd/mybenk/mybenk_prd_environment.ts',
  envName: 'HML',
  production: true,
  firebase: {
    apiKey: "AIzaSyADtNj_n0IhXyxhAzqPp-tQChRoETwrdco",
    authDomain: "celcoin-prd.firebaseapp.com",
    projectId: "celcoin-prd",
    storageBucket: "celcoin-prd.appspot.com",
    messagingSenderId: "940968013662",
    appId: "1:940968013662:web:38c22caa5763bbbdcd69cf"
  },

  tenants: [
    {
      tenant: "rondonbenk-rvlfj",
      name: "rondonbenk",
      primaryColor: "#5749C2",
      overPrimary: "#000000",
      icon: "https://storage.googleapis.com/celcoin-prd.appspot.com/tenant-assets/rondonbenk/icon",
      apiKey: "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJEaWxldHRhIFNvbHV0aW9ucyIsImlhdCI6MTc1MDc5MjAwMTc4MywiYXVkIjoiY2VsY29pbi1wcmQiLCJzdWIiOiJyb25kb25iZW5rIiwianRpIjoiNTg0NmE2OWItMGEzYi00NTQ3LWE1YmQtMDM2NDcyODI4MGY2IiwidGVuYW50SWQiOiJyb25kb25iZW5rLXJ2bGZqIn0.gIEuoOSELRhLyADrYsSb9su5nG2plR4juqLxOVaymHRhiat076eR6F-jPpl2gsn7yl1Cg9oV44k5JogNYGhfyg",
      client: "matera",
      clientSuite: true,
      infoHeader: false,
      biz: false,
      apiUrl: 'https://api.rondonbenk.dilettapay.app',
      formattedName: "Rondôn Benk",
      logo: "https://storage.googleapis.com/celcoin-prd.appspot.com/tenant-assets/rondonbenk/logo",
      logoLogin: "https://storage.googleapis.com/celcoin-prd.appspot.com/tenant-assets/rondonbenk/logo-login",
      minimalLogin: false
    }
  ],
  apiUrl: 'https://api.rondonbenk.dilettapay.app',
  apiUrlFunctions: 'https://us-central1-celcoin-prd.cloudfunctions.net',
  keyEncryptAuth: 'oGTy7QtyHr48GE6re5KTckkGnbm6oo7SwRHsi2gqjapqflY9hjTAJ4GyUtt9YrSK',
  account: '413453',
  branch: '3100',
  wallet: '109',
  bank: '341',
  currency: '9'
}